export default __webpack_public_path__ + "static/media/tab-all.1927885d.svg";